import EntityTable from "@mirage/components/entityTable/EntityTable";
import LinkCell from "@mirage/components/entityTable/components/LinkCell";
import { Box } from "@mui/system";
import { GridColDef } from "@mui/x-data-grid-premium";
import EnforcementNoticeService from "@publicPortal/services/EnforcementNoticeService";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";
import { IEntityPageRequest } from "@shared/mirage/core/contracts/IEntityPageRequest";
import React, { memo, useCallback, useMemo } from "react";
import { SearchResultTableProps } from "./PlanningApplicationsTable";
import { useDeviceDetect } from "@mirage/hooks/useDeviceDetect";
import { TablePaginationBaseProps } from "@mui/material/TablePagination";

const pp = new PublicPortalRoutingService();
const enfService = new EnforcementNoticeService();

const EnforcementNoticeTable: React.FC<SearchResultTableProps> = memo(({ filter, title, customPageRequest }) => {
    const { isMobile } = useDeviceDetect();
    const getRecordDetailsUrl = useCallback((id: number) => pp.EnforcementNoticesRecordRoute(id), []);
    const columns = useMemo((): GridColDef[] => {
        return [
            { field: "name", headerName: "Notice Reference", renderCell: (params) => <LinkCell value={params.value} route={getRecordDetailsUrl(Number(params.id))} />, width: 140 },
            { field: "dateAuthorised", headerName: "Date Authorised", type: "date", width: 120 },
            { field: "futureAction", headerName: "Future Action", width: 140 },
            { field: "noticeStatus", headerName: "Notice Status", width: 140 },
        ];
    }, [getRecordDetailsUrl]);
    const onPageRequest = useCallback(
        async (pageRequest: IEntityPageRequest) => {
            if (customPageRequest) {
                return await customPageRequest(pageRequest);
            }
            const response = await enfService.pageRequest(pageRequest);
            return response;
        },
        [customPageRequest]
    );
    const overridePaginationProps = useCallback((baseProps: TablePaginationBaseProps) => ({ ...baseProps, showFirstButton: false, showLastButton: false }), []);

    return (
        <Box sx={{ height: "auto" }}>
            <EntityTable
                title={title}
                key="enforcement-notices-entityTable"
                stateKey="enforcementNotices"
                onPageRequest={onPageRequest}
                columns={columns}
                filter={filter}
                hideRowsPerPage={isMobile}
                overridePaginationProps={overridePaginationProps}
            />
        </Box>
    );
});

export default EnforcementNoticeTable;
